module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isDisabled,
      "loading": _vm.isSubmitted
    },
    on: {
      "click": _vm.onSend
    }
  }, [_vm._v("\n    " + _vm._s(_vm.isSubmitted ? 'Salvando' : 'Salvar') + " Alterações\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6eeb83e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/form/SaveButton.vue
// module id = 764
// module chunks = 2